import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Modal,
  Nav,
  BreadcrumbItem,
  Breadcrumb,
  Table,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  useGetEmployeeListMutation,
  useGetOptionsMutation,
} from "../../slices/commonApiSlice";
import { parseOptionsData } from "../../utils/parseOptionsData";
import { parseUserInfo } from "../../utils/parseUtil";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { useGetYearlyBonusReportsMutation } from "../../slices/adminApiSlice";
import axios from "axios";
import { PFYEARLYREPORT_URL } from "../../constants";

const YearlyMandaysReport = () => {
  const [year, setYear] = useState("");
  const [empType, setEmpType] = useState("");
  const [empName, setEmpName] = useState("");
  const [empCode, setEmpCode] = useState("");
  const [activeType, setActiveType] = useState("0");
  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [employeeSuggestions, setEmployeeSuggestions] = useState([]);
  const [payDate, setPayDate] = useState("");
  const [submittedData, setSubmittedData] = useState(null);
  const [reqChkXl, setReqChkXl] = useState("");
  const [yearsOptions, setYearsOptions] = useState([]);
  const [checkSupress, setCheckSupress] = useState(false);
  const [checkReTransfer, setCheckReTransfer] = useState(false);
  const [checkProvisional, setCheckProvisional] = useState(false);

  const handleReportType = (type) => {
    setReqChkXl(type);
  };
  const { userInfo } = useSelector((state) => state.auth);

  const [getYearlyBonusReports, { isLoading }] =
    useGetYearlyBonusReportsMutation();

  const [getOptions, { isLoading: getOptionsLoading }] =
    useGetOptionsMutation();
  const [getEmpName] = useGetEmployeeListMutation();

  const [employeeTypes, setEmployeeTypes] = useState([]);

  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();

    const startYear = parseInt(process.env.REACT_APP_START_YEAR, 10 || 2020);

    const options = [];
    for (let i = startYear; i <= currentYear + 1; i++) {
      options.push(i);
    }

    setYearsOptions(options);
    setYear(currentYear.toString());

    // Fetch options data on component load
    const fetchOptions = async () => {
      try {
        const reqCompanyCode = userInfo[13]?.InfoField || "1"; // Default to '1' if not available

        const formData = new FormData();
        formData.append("title", "GetEmployeeMasterDataList");
        formData.append("ReqCompanyCode", reqCompanyCode);

        const res = await getOptions(formData);

        const parsedOptions = parseUserInfo(res);
        const parsedData = parseOptionsData(parsedOptions);

        console.log(parsedData, "12");

        if (parsedData) {
          setEmployeeTypes(parsedData.employeeTypes);
        } else {
          toast.error("Failed to load options");
        }
      } catch (err) {
        console.error("Error fetching options:", err);
        toast.error("Error fetching options");
      }
    };

    fetchOptions();
  }, [getOptions, userInfo]);

  const handleEmployeeSearch = async (input) => {
    if (input.length < 3) {
      setEmployeeSuggestions([]); // Clear suggestions if input is less than 3 characters
      return;
    }

    try {
      const reqCompanyCode = userInfo[13]?.InfoField || "1"; // Default to '1' if not available
      const formData = new FormData();
      formData.append("title", "GetEmployeeList");
      formData.append("ReqCompanyCode", reqCompanyCode);
      formData.append("ReqSearchStr", input);

      const res = await getEmpName(formData);
      const parsedData = parseUserInfo(res);

      if (parsedData && parsedData.length > 0) {
        const employeeList = JSON.parse(parsedData[0].JSONData1);
        setEmployeeSuggestions(employeeList);
      } else {
        setEmployeeSuggestions([]);
        toast.error("No employees found");
      }
    } catch (err) {
      console.error("Error fetching employee list:", err);
      toast.error("Error fetching employee list");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const reqCompanyCode = userInfo[13]?.InfoField;

    const formData = new FormData();
    formData.append("title", "GetYearlyPFESIReports");
    formData.append("description", "GetYearlyPFESIReports");
    formData.append("ReqRptType", 2);
    formData.append("ReqYear", year);
    formData.append("ReqEmpCode", empCode);
    formData.append("ReqCompanyCode", reqCompanyCode);
    // formData.append('ReqActiveType', activeType)
    formData.append("ReqPayEmpType", empType);
    // formData.append('ReqChkXl', reqChkXl)
    // formData.append('ReqChkProvi', checkProvisional ? '1' : '0')
    // formData.append('ReqChkSuppr', checkSupress ? '1' : '0')
    // formData.append('ReqChkTransfer', checkReTransfer ? '1' : '0')
    // formData.append('ReqPayDate', 0)

    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    // Save form data to state to display in the table
    setSubmittedData({
      empName,
      year,
      empType,
      empCode,
      activeType,
      payDate,
      checkReTransfer,
      checkSupress,
      checkProvisional,
    });

    try {
      const res = await axios.post(PFYEARLYREPORT_URL, formData);

      const parsedData = parseUserInfo(res.data);

      if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
        const data = parsedData[0];

        if (data.ErrorCode === "0") {
          let pdfPath = data.JSONData1;

          if (pdfPath.startsWith("/api/WebServiceBonusReports.aspx/")) {
            pdfPath = pdfPath.replace("/api/WebServiceBonusReports.aspx/", "/");
          }

          const backendUrl = process.env.REACT_APP_URL;
          const pdfUrl = `${backendUrl}${pdfPath}`;

          setPdfUrl(pdfUrl);
          setShowModal(true);
        } else {
          toast.error(data.ErrorMessage || "An error occurred");
        }
      } else {
        toast.error("Failed to parse user info");
      }
    } catch (err) {
      console.error("Error submitting data:", err);
      toast.error(err?.data?.message || "Error submitting data");
    }
  };

  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem>
          <Nav.Link
            as={Link}
            to="/dashboard"
            className="text-success text-decoration-none"
          >
            Dashboard
          </Nav.Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Yearly Mandays Report</BreadcrumbItem>
      </Breadcrumb>
      <Container className="form-container">
        <h4 className="text-center">Yearly Mandays Report</h4>
        <Form
          className="border p-4 rounded bg-light mb-4"
          onSubmit={handleSubmit}
        >
          <Row className="">
            <Col md={6}>
              <Form.Group controlId="empName">
                <Form.Label>Employee Name</Form.Label>
                <Typeahead
                  id="empName-typeahead"
                  onInputChange={(input) => {
                    setEmpName(input);
                    handleEmployeeSearch(input);
                  }}
                  onChange={(selected) => {
                    if (selected.length > 0) {
                      setEmpName(selected[0].EmployeeName);
                      setEmpCode(selected[0].Empcode);
                    }
                  }}
                  options={employeeSuggestions}
                  labelKey="EmployeeName"
                  placeholder="Choose an employee..."
                  selected={empName ? [{ EmployeeName: empName }] : []}
                  className="form-control-hover"
                  minLength={3}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="empCode" className="mb-3">
                <Form.Label>Employee Code</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Employee Code"
                  value={empCode}
                  onChange={(e) => setEmpCode(e.target.value)}
                  className="form-control-hover"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="year">
                <Form.Label>Year</Form.Label>
                <Form.Control
                  as="select"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                  className="form-control-hover"
                  required
                >
                  {yearsOptions.map((yr) => (
                    <option key={yr} value={yr}>
                      {yr}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="empType">
                <Form.Label>Employee Type</Form.Label>
                <Typeahead
                  id="empType-typeahead"
                  onChange={(selected) => setEmpType(selected[0])}
                  options={employeeTypes}
                  placeholder="Choose an employee type..."
                  selected={empType ? [empType] : []}
                  className="form-control-hover"
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          {/* <Row className="">
            <Col md={6}>
              <Form.Group controlId="payDate" className="mb-3">
                <Form.Label>Pay Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Enter Pay Date"
                  value={payDate}
                  onChange={(e) => setPayDate(e.target.value)}
                  className="form-control-hover"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="activeType">
                <Form.Label>Active Type</Form.Label>
                <Form.Control
                  as="select"
                  value={activeType}
                  onChange={(e) => setActiveType(e.target.value)}
                  className="form-control-hover"
                  required
                >
                  <option value="0">All</option>
                  <option value="1">Active</option>
                  <option value="2">Dropped</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>{" "} */}
          {/* <Row className="mb-3">
            <Col md={12}>
              <Form.Group>
                <Form.Label>
                  <div className="headline">Options</div>
                </Form.Label>
                <div className="d-flex justify-content-around">
                  <Form.Check
                    type="checkbox"
                    id="checkReTransfer"
                    name="checkReTransfer"
                    label="Re Transfer Bonus Master"
                    checked={checkReTransfer}
                    onChange={(e) => setCheckReTransfer(e.target.checked)}
                  />
                  <Form.Check
                    type="checkbox"
                    id="checkSupress"
                    name="checkSupress"
                    label="Supress Zero Records"
                    checked={checkSupress}
                    onChange={(e) => setCheckSupress(e.target.checked)}
                  />
                  <Form.Check
                    type="checkbox"
                    id="checkProvisional"
                    name="checkProvisional"
                    label="Provisional"
                    checked={checkProvisional}
                    onChange={(e) => setCheckProvisional(e.target.checked)}
                  />
                </div>
              </Form.Group>
            </Col>
          </Row> */}
          <Row className="mb-3 text-center">
            <Col>
              <Button
                type="submit"
                variant="danger"
                className="px-4"
                disabled={isLoading || getOptionsLoading}
                onClick={() => handleReportType(0)}
              >
                {isLoading || getOptionsLoading ? "Loading..." : "PRINT PDF"}
              </Button>
            </Col>
            {/* <Col>
              <Button
                type="submit"
                variant="success"
                className="px-4"
                disabled={isLoading || getOptionsLoading}
                onClick={() => handleReportType(1)}
              >
                {isLoading || getOptionsLoading ? "Loading..." : "PRINT EXCEL"}
              </Button>
            </Col> */}
          </Row>
        </Form>

        {/* Render table with submitted data */}
        {/* {submittedData && (
          <Table striped bordered hover className="mt-4">
            <thead>
              <tr>
                <th>Employee Name</th>
                <th>Year</th>
                <th>Month</th>
                <th>Employee Type</th>
                <th>Employee Code</th>
                <th>Active Type</th>
                <th>Pay Date</th>
                <th>Report Type</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{submittedData.empName}</td>
                <td>{submittedData.year}</td>
                <td>{submittedData.month}</td>
                <td>{submittedData.empType}</td>
                <td>{submittedData.empCode}</td>
                <td>{submittedData.activeType}</td>
                <td>{submittedData.payDate}</td>
                <td>{submittedData.reportType}</td>
              </tr>
            </tbody>
          </Table>
        )} */}

        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Yearly Mandays Report</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <iframe
              src={pdfUrl}
              width="100%"
              height="500px"
              title="Yearly Mandays Report"
            ></iframe>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default YearlyMandaysReport;
